import Page from "./Page";
export default class PageCategory {
  constructor(rawData = {}) {
    this.id = rawData.id;
    this.name = rawData.name;
    this.pages = new Page(rawData.contentTypeList);
  }
}
